// import { createClient } from '@supabase/supabase-js'

// export const supabase = createClient(supabaseUrl, supabaseAnonKey)
// src/supabase/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables: VUE_APP_SUPABASE_URL and VUE_APP_SUPABASE_ANON_KEY must be set.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-queryjuriste-auth', // clé unique et stable
    detectSessionInUrl: true,
  },
  realtime: { params: { eventsPerSecond: 10, debug: true } },
});
